module.exports = __webpack_public_path__ + "img/28.ca3900e9.jpg";